const F = require('./formatter');

module.exports = {
    // Translated.
    docApprovalReportPendingAllHelp: () => F('doc-approval-report-pending-all-help', null, null, true),
    docApprovalReportPendingSelectedHelp: () => F('doc-approval-report-pending-selected-help', null, null, true),
    docApprovalReportPendingAnyHelp: () => F('doc-approval-report-pending-any-help', null, null, true),
    docApprovalReportRejectedStatusHelp: () => F('doc-approval-report-rejected-status-help', null, null, true),
    docApprovalReportApprovedStatusHelp: () => F('doc-approval-report-approved-status-help', null, null, true),
    docApprovalReportPendingStatusHelp: () => F('doc-approval-report-pending-status-help', null, null, true),
    docApprovalReportAnyStatusHelp: () => F('doc-approval-report-any-status-help', null, null, true),
    entryTypeRequired: () => F('entry-type-required', null, null, true),
    wellAuditTemplateRequired: () => F('wellbore-audit-template-required', null, null, true),
    dayRequired: () => F('day-required', null, null, true),
    timeZoneRequired: () => F('time-zone-required', null, null, true),
    timeRequired: () => F('time-required', null, null, true),
    endDateRequired: () => F('end-date-required', null, null, true),
    startDateRequired: () => F('start-date-required', null, null, true),
    reportScheduleInvalid: () => F('report-schedule-invalid', null, null, true),
    reportTitleRequired: () => F('report-title-required', null, null, true),
    reportTypeRequired: () => F('report-type-required', null, null, true),
    reportNameRequired: () => F('report-name-required', null, null, true),
    requestAccessSuccess: () => F('request-access-success', null, null, true),
    forgotPasswordRequestFail: () => F('forgot-password-request-fail', null, null, true),
    forgotPasswordRequestSuccess: () => F('forgot-password-request-success', null, null, true),
    resendEmailHelp: () => F('resend-email-help', null, null, true),
    resendTextHelp: () => F('resend-text-help', null, null, true),
    wellUsersCompanyHelp: () => F('well-users-company-help', null, null, true),
    wellUsersEmailHelp: () => F('well-users-email-help', null, null, true),
    wellUsersUsernameHelp: () => F('well-users-username-help', null, null, true),
    videoTagNotSupported: () => F('video-tag-not-supported', null, null, true),
    helpListHelp: () => F('help-list-help', null, null, true),
    recycleBinRestoreFileHelp: () => F('recycle-bin-restore-file-help', null, null, true),
    recycleBinWellDeletedHelp: () => F('recycle-bin-well-deleted-help', null, null, true),
    reportWellPropertiesEditHelp: () => F('report-well-properties-edit-help', null, null, true),
    reportPublishOnHelp: () => F('report-publish-on-help', null, null, true),
    reportPublishOffHelp: () => F('report-publish-off-help', null, null, true),
    reportScheduledOnHelp: () => F('report-scheduled-on-help', null, null, true),
    reportHeadersCompressedHelp: () => F('report-headers-compressed-help', null, null, true),
    reportHeadersStandardHelp: () => F('report-headers-standard-help', null, null, true),
    reportRemarksFormatRichHelp: () => F('report-remarks-format-rich-help', null, null, true),
    reportRemarksFormatStandardHelp: () => F('report-remarks-format-standard-help', null, null, true),
    reportRemarksLayoutBeneathHelp: () => F('report-remarks-layout-beneath-help', null, null, true),
    reportRemarksLayoutBesideHelp: () => F('report-remarks-layout-beside-help', null, null, true),
    reportDateRangeHelp: () => F('report-date-range-help', null, null, true),
    reportShowSingle: () => F('report-show-single', null, null, true),
    savedSearchNewHelp: () => F('saved-search-new-help', null, null, true),
    savedSearchExistingHelp: () => F('saved-search-existing-help', null, null, true),
    resetPasswordSuccess: () => F('reset-password-success', null, null, true),
    forgotPasswordOperationSucceeded: () => F('forgot-password-operation-succeeded', null, null, true),
    alertsSaved: () => F('alerts-saved', null, null, true),
    deleteAllAlerts: () => F('delete-all-alerts', null, null, true),
    selectedWellAlerts: () => F('selected-well-alerts', null, null, true),
    selectedRigAlerts: () => F('selected-rig-alerts', null, null, true),
    selectedAssetAlerts: () => F('selected-asset-alerts', null, null, true),
    allWellAlerts: () => F('all-well-alerts', null, null, true),
    selectAtLeastOneEntryType: () => F('select-at-least-one-entry-type', null, null, true),
    companyRequired: () => F('company-required', null, null, true),
    badCredentials: () => F('bad-credentials', null, null, true),
    // This is special case, handling messages from the server that need to be translated (ie. login page errors).
    // The server just sends the key to lookup.
    handleServerError: (key) => F(key, null, null, true),
    resetPasswordFail: () => F('reset-password-fail', null, null, true),
    unableReachServer: () => F('unable-reach-server', null, null, true),
    enterUsername: () => F('enter-username', null, null, true),
    enterPassword: () => F('enter-password', null, null, true),
    enterPasswordConfirm: () => F('enter-password-confirm', null, null, true),
    sendTestEmailSucceeded: () => F('send-test-email-succeeded', null, null, true),
    sendTestEmailFailed: () => F('send-test-email-failed', null, null, true),
    sendTestMessageSucceeded: () => F('send-test-message-succeeded', null, null, true),
    sendTestMessageFailed: () => F('send-test-message-failed', null, null, true),
    firstNameEmpty: () => F('first-name-empty', null, null, true),
    lastNameEmpty: () => F('last-name-empty', null, null, true),
    validateSelectEntryType: () => F('validate-select-entry-type', null, null, true),
    enterContactName: () => F('enter-contact-name', null, null, true),
    enterValidEmail: () => F('enter-valid-email', null, null, true),
    enterValidPhoneNumber: () => F('enter-valid-phone-number', null, null, true),
    enterValidNonUsaPhoneNumber: () => F('enter-valid-nonusa-phone-number', null, null, true),
    error404General: () => F('error-404-general', null, null, true),
    remarksTemplateIncomplete: () => F('entry-remarks-template', null, null, true),
    remarksEmpty: () => F('entry-remarks', null, null, true),
    // JB
    // TODO
    // Find a way to weed out this situation where we have two separate validation messages conveying the exact same thing, separated only by how they're triggered/displayed.
    enterRemarks: () => F('enter-remarks', null, null, true),
    noPdfSelected: () => F('no-pdf-selected', null, null, true),
    noPdfFound: () => F('no-pdf-found', null, null, true),
    downloadFail: () => F('download-fail', null, null, true),
    noSelection: () => F('no-selection', null, null, true),
    entryFileRequired: () => F('entry-file-required', null, null, true),
    searchMoreSpecificCriteria: () => F('search-more-specific-criteria', null, null, true),
    searchInRemarks: () => F('search-in-remarks', null, null, true),
    searchHasNoResult: () => F('search-has-no-result', null, null, true),
    maxAttachmentSizeHelp: () => F('max-attachment-size-help', null, null, true),
    entryAddUploadDateHelp: () => F('entry-add-upload-date-help', null, null, true),
    searchMatchingFilesNoHelp: () => F('search-only-matching-files-no-help', null, null, true),
    searchFilenameHelp: () => F('search-filename-help', null, null, true),
    saveSearchHelpNoColumns: () => F('save-search-help-no-columns', null, null, true),
    saveSearchHelp: () => F('save-search-help', null, null, true),
    alertStatusMaster: () => F('alert-status-master', null, null, true),
    alertStatusAsset: () => F('alert-status-asset', null, null, true),
    alertStatusRig: () => F('alert-status-rig', null, null, true),
    alertStatusWell: () => F('alert-status-well', null, null, true),
    alertStatusWellGroup: () => F('alert-status-well-group', null, null, true),
    mustSelectSpudDate: () => F('must-select-spud-date', null, null, true),
    mustSelectSpudDateRange: () => F('must-select-spud-date-range', null, null, true),
    mustEnterMonthsPrevious: () => F('must-enter-months-previous', null, null, true),
    reportSubscribeColumnHelp: () => F('report-subscribe-column-help', null, null, true),
    entryDaRejectLock: () => F('entry-da-reject-lock', null, null, true),
    entryDaRejectNoLock: () => F('entry-da-reject-no-lock', null, null, true),
    gridNoItems: () => F('grid-no-items', null, null, true),
    alternate: () => F('alternate', null, null, true),
    gridItemsPerPage: () => F('grid-items-per-page', null, null, true),
    entryDeleted: () => F('entry-deleted', null, null, true),
    noEntryHistory: () => F('no-entry-history', null, null, true),
    docApprovalAlertDescription: () => F('doc-approval-alert-desc', null, null, true),
    docApprovalAlertEntryUploadedDescription: () => F('doc-approval-alert-entry-uploaded-desc', null, null, true),
    docApprovalAlertStepDescription: () => F('doc-approval-alert-step-desc', null, null, true),
    docApprovalAlertFullyApprovedDescription: () => F('doc-approval-alert-fully-approved-desc', null, null, true),
    docApprovalAlertRejectedDescription: () => F('doc-approval-alert-rejected-desc', null, null, true),
    multiAlertsDescripiton: () => F('multi-alerts-desc', null, null, true),
    alertOnDescription: () => F('alert-on-desc', null, null, true),
    alertOffDescription: () => F('alert-off-desc', null, null, true),
    pauseAllNotifications: () => F('pause-all-notifications', null, null, true),
    allNotificationsPaused: () => F('all-notifications-paused', null, null, true),
    loginTitle: () => F('login-title', null, null, true),
    loginHeader: () => F('login-header', null, null, true),
    forgotPasswordDescription: () => F('forgot-password-description', null, null, true),
    loginBody: () => F('login-body', null, null, true),
    loginTagline: () => F('login-tagline', null, null, true),
    appsAvailable: () => F('apps-available', null, null, true),
    uploads: () => F('uploads', null, null, true),
    uptime: () => F('uptime', null, null, true),
    ownersAndOperators: () => F('owners-and-operators', null, null, true),
    serviceCompanies: () => F('service-companies', null, null, true),
    activeUsers: () => F('active-users', null, null, true),
    operationsSupport: () => F('operations-support', null, null, true),
    salesAndMarketing: () => F('sales-and-marketing', null, null, true),
    lockedOutBody1: () => F('locked-out-body1', null, null, true),
    lockedOutBody2: () => F('locked-out-body2', null, null, true),
    lookingForMoreInfo: () => F('looking-for-more-info', null, null, true),
    lookingForMoreInfoBody: () => F('looking-for-more-info-body', null, null, true),
    comingSoon: () => F('coming-soon', null, null, true),
    newUser: () => F('new-user', null, null, true),
    newUserBody: () => F('new-user-body', null, null, true),
    sessionExpiredContinue: () => F('session-expired-continue', null, null, true),
    sessionTimeoutStatus: () => F('session-timeout-status', null, null, true),
    sessionContinue: () => F('session-continue', null, null, true),
    tbd: () => F('tbd', null, null, true),
    notTbd: () => F('not-tbd', null, null, true),
    searchByApi: () => F('search-by-api', null, null, true),
    rigNoCompanyMessage: () => F('rig-no-company-message', null, null, true),
    downloadCombinedPdf: () => F('download-combined-pdf', null, null, true),
    combinedPdf: () => F('combined-pdf', null, null, true),
    usa: () => F('usa', null, null, true),
    entryAddContact: () => F('entry-add-contact', null, null, true),
    termsAndConditions: () => F('terms-and-conditions', null, null, true),
    attachmentSizeLimit: () => F('attachment-size-limit', null, null, true),
    // Special handling for wellbore tag grid filter placeholders.
    searchByTag: (keys) => F(keys, 'search', null, true),
    entryIncomplete: () => F('entry-incomplete', null, null, true),
    passwordEmpty: () => F('password-empty', null, null, true),
    newPasswordEmpty: () => F('new-password-empty', null, null, true),
    passwordConfirmationMismatch: () => F('password-confirmation-mismatch', null, null, true),
    startDateLessThanEndDate: () => F('start-date-less-than-end-date', null, null, true),
    datePanelHelp: () => F('date-panel-help', null, null, true),
    reportTimeSpanHelp: () => F('report-time-span-help', null, null, true),
    otherIssuesBody: () => F('other-issues-body', null, null, true),
    reportMatchAllEntryTypesHelp: () => F('report-match-all-entry-types-help', null, null, true),
    reportMatchAnyEntryTypesHelp: () => F('report-match-any-entry-types-help', null, null, true),
    shl: () => F('shl', null, null, true),
    bhl: () => F('bhl', null, null, true),
    searchByAfe: () => F('search-by-afe', null, null, true),
    noTemplateFieldError: () => F('no-template-field-error', null, null, true),
    duplicateTemplateFieldError: () => F('duplicate-template-field-error', null, null, true),
    defautHeaderTitle: () => F('defaut-header-title', null, null, true),
    copyFromDefaultTitle: () => F('copy-from-default-title', null, null, true),
    copyFromDefaultTemplate: () => F('copy-from-default-template', null, null, true),
    deleteTemplate: () => F('delete-template', null, null, true),
    backToAfe: () => F('back-to-afe', null, null, true),
    afe: () => F('afe', null, null, true),
    templateAfe: () => F('template-afe', null, null, true),
    downloadAfe: () => F('download-afe', null, null, true),
    addAfe: () => F('add-afe', null, null, true),
    reviewOriginalAfe: () => F('review-original-afe', null, null, true),
    saveAfeAsTemplate: () => F('save-afe-as-template', null, null, true),
    setRangeHelp: () => F('set-range-help', null, null, true),
    deleteAfe: () => F('delete-afe', null, null, true),
    saveAfeAsTemplateWarning: () => F('save-afe-as-template-warning', null, null, true),
    loadAfeTemplateWarning: () => F('load-afe-template-warning', null, null, true),
    afeGlobalValueOtherSectionInUse: () => F('afe-global-value-other-section-in-use', null, null, true),
    afeGlobalValueOtherSectionComplete: () => F('afe-global-value-other-section-complete', null, null, true),
    afeGlobalValueCalculationWarning: () => F('afe-global-value-calculation-warning', null, null, true),
    afeGlobalValueSectionComplete: () => F('afe-global-value-section-complete', null, null, true),
    afeSectionValueSectionComplete: () => F('afe-section-value-section-complete', null, null, true),
    resetAfeSectionLineItems: () => F('reset-afe-section-line-items', null, null, true),
    resetAfeSectionValues: () => F('reset-afe-section-values', null, null, true),
    resetAfeGlobalValues: () => F('reset-afe-global-values', null, null, true),
    currentUserHasAfeSectionsOpenPart1: () => F('current-user-has-afe-sections-open-part-1', null, null, true),
    currentUserHasAfeSectionsOpenPart2: () => F('current-user-has-afe-sections-open-part-2', null, null, true),
    prodDeleteSavedExport: () => F('prod-delete-saved-export', null, null, true),
    prodExportNoData: () => F('prod-export-no-data', null, null, true),
    prodDataExportColumnsHelp: () => F('prod-data-export-columns-help', null, null, true),
    prodDataExportCompanyHelp: () => F('prod-data-export-company-help', null, null, true),
    prodDataExportLimitsHelp: () => F('prod-data-export-limits-help', null, null, true),
    prodDataExportEntryTypeHelp: () => F('prod-data-export-entry-type-help', null, null, true),
    batchCopyWellHeaderHelp: () => F('batch-copy-well-header-help', null, null, true),
    batchCopyWellFooterHelp: () => F('batch-copy-well-footer-help', null, null, true),
    searchNameRequired: () => F('search-name-required', null, null, true),
    daysValueRequired: () => F('days-value-required', null, null, true),
    monthsValueRequired: () => F('months-value-required', null, null, true),
    dateRangesHelp: (userId) => F('date-ranges-help', null, null, true),
    userTimeZoneHelp: (userId) => F('user-time-zone-help', null, null, true),
    userCompanyOrRoleTypeRequired: () => F('user-company-or-role-type-required', null, null, true),
    userCompanyRequired: () => F('user-company-required', null, null, true),
    dateRangesHelp: () => F('date-ranges-help', null, null, true),
    userTimeZoneHelp: () => F('user-time-zone-help', null, null, true),
    configDownloadHelp: () => F('config-download-help', null, null, true),
    browserNotSupported1: () => F('browser-not-supported-1', null, null, true),
    browserNotSupported2: () => F('browser-not-supported-2', null, null, true),
    chromeDownloadTooltip: () => F('chrome-download-tooltip', null, null, true),
    firefoxDownloadTooltip: () => F('firefox-download-tooltip', null, null, true),
    edgeDownloadTooltip: () => F('edge-download-tooltip', null, null, true),
    safariDownloadTooltip: () => F('safari-download-tooltip', null, null, true),
    remarksTooLarge: () => F('remarks-too-large', null, null, true),
    spudDateRequired: (userId) => F('spud-date-required', null, null, true),
    apiValidation: () => F('api-invalid', null, null, true),
    groupNameRequired: () => F('group-name-required', null, null, true),
    reportDeleteConfirm: () => F('report-delete-confirm', null, null, true),
    fileFormatRequired: () => F('file-format-required', null, null, true),
    statusRequired: () => F('status-required', null, null, true),
    mustSelecteSpudDateOruploadDate: () => F('must-select-spud-date-or-upload-date', null, null, true),
    entryContactRequired: () => F('entry-contact-required', null, null, true),
    entryDenyFutureEditDate: () => F('entry-deny-future-edit-date', null, null, true),
    updateProfileHelp: () => F('update-profile-help', null, null, true),
    cellNumberRequired: () => F('cell-number-required', null, null, true),
    cellCarrierRequired: () => F('cell-carrier-required', null, null, true),
    prodDataExportFilenameHelp: () => F('prod-data-export-file-name-help', null, null, true),
    prodOutputFormatHelp: () => F('prod-output-format-help', null, null, true),
    columnRequired: () => F('column-required', null, null, true),
    formatNameRequired: () => F('format-name-required', null, null, true),
    downloadFailed: () => F('download-failed', null, null, true),
    reportValidationFailed: () => F('report-validation-failed', null, null, true),
    deleteWellGroupFailedTitle: () => F('delete-well-group-failed-title', null, null, true),
    deleteWellGroupFailedReason: () => F('delete-well-group-failed-reason', null, null, true),
    insufficientPermissions: () => F('insufficient-permissions', null, null, true),
    showRecentUsed: () => F('show-recent-used', null, null, true),
    confirmDeleteSelectedContacts: () => F('confirm-delete-selected-contacts', null, null, true),
    combinedPdfReportRigHelp: () => F('combined-pdf-report-rig-help', null, null, true),
    sendMailWhenNoDataNo: () => F('send-mail-when-no-data-no', null, null, true),
    sendMailWhenNoDataYes: () => F('send-mail-when-no-data-yes', null, null, true),
    ReportIsEmpty: () => F('report-is-empty', null, null, true),
    // -------------------------------------------------------------------------

    // Not translated.
    entryTypePermissionsAlertWarning: () => `If changes made to this role's entry type permissions result in the effective loss of access to an entry type for any users, all alerts for that entry type for those users will also be removed.`,
    docApprovalStatusTip: () => `
        <div class="tooltip-text-paragraph">
            Pending:&#160; Show entries that still have pending approvals for at least one step.<br /><br />
            Approved:&#160; Show entries that are fully approved.<br /><br />
            Rejected:&#160; Show entries that are rejected.
        </div>
    `,
    showDocApprovalStepsTip: () => `
        <div class="tooltip-text-paragraph">
            Show any entry that is pending for any of these steps.<br /><br />
            Leave blank to show entries still awaiting approvals (entries pending for any step).<br /><br />
            Choose all steps for new entries (entries pending for all steps).
        </div>
    `,
    resendAlertsEntrySelectionHelp: () => `
        <dl>
            <dt>Company</dt>
            <dd>
                <ul>
                    <li class="text-danger">Required.</li>
                    <li>Selections will filter wells, entry types, roles and users.</li>
                </ul>
            </dd>
            <dt>Well Stage</dt>
            <dd>
                <ul>
                    <li>Optional.</li>
                    <li>Selection will filter wells and entry types.</li>
                </ul>
            </dd>
            <dt>Wells</dt>
            <dd>
                <ul>
                    <li>If Well Stage is set to <b>None</b>, selection is limited to 1 well.  Otherwise, multi-select is available.</li>
                    <li>Selections will filter entry types.</li>
                    <li>No selection means entries on all wells of the selected company or well stage will be included.</li>
                </ul>
            </dd>
            <dt>Entry Type</dt>
            <dd>
                <ul>
                    <li>Optional.</li>
                    <li>No selection means entries of all entry types for the selected company and/or well(s) will be included.</li>
                </ul>
            </dd>
        </dl>
    `,
    resendAlertsRecipientSelectionHelp: () => `
        <dl>
            <dt>Role</dt>
            <dd>
                <ul>
                    <li>Optional.</li>
                    <li>Selections will filter users.</li>
                    <li>No selection means users of all roles of the selected company are potential recipients.</li>
                </ul>
            </dd>
            <dt>User</dt>
            <dd>
                <ul>
                    <li>Optional.</li>
                    <li>No selection means all users of the selected company and/or roles are potential recipients.</li>
                </ul>
            </dd>
            <dt>Send only to users with Notifications</dt>
            <dd>
                <ul>
                    <li>When set to <b>Yes</b> (default), alerts will only be sent to eligible users with Notification preferences, according to those preferences.
                    <li>When set to <b>No</b>, alerts will be sent to all eligible users, according to the alert types selected.  At least one alert type selection is required before you can send.
                </ul>
            </dd>
        </dl>
    `,
    volumeLegend: () => `
        <dl class="help-definition-list">
            <dt class="alert alert-special">
                Disabled
            </dt>
            <dd>
                This volume is unavailable for both reads and writes. 
            </dd>
            <dt class="alert alert-danger">
                Read Only
            </dt>
            <dd>
                The volume is not available for writes.  It is still available for reads.
            </dd>
        </dl>
    `,
    wellEntryTypeHelp: () => `
        <p class="h4">
            Count of Entries
        </p>
        <div class="alert alert-warning">
            Controls how many total entries of this type should appear in the well for it to pass the audit. <br />
            Leaving this blank means any number of entries (even 0) is valid.<br />
            Any number greater than 0 means that the well must contain exactly that number of entries to pass.
        </div>
        <p class="h4">
            Required In Remarks
        </p>
        <div class="alert alert-warning">
            Count controls how many of the entries existing in the well must match the given text/expression.
        </div>
    `,
    noUserFoundToReceiveAlerts: () => 'No eligible users found to receive alerts, according to the selected criteria.',
    startDateGreaterOrEqualEndDate: () => 'The end date must be greater than start date.',
    userRoleRequired: () => 'No user role selected.',
    wellboreRequired: () => 'No well selected.',
    reportCriteriaRequired: () => `Report criteria must be specified.`,
    rigsRequired: () => `One or more rigs must be specified`,
    runTimesRequired: () => `One or more run times must be specified`,
    uploadEntryTypeRequired: () => `Upload Entry Type must be specified.`,
    uploadWellRequired: () => `Upload Well must be specified.`,
    hoursBackRequired: () => `Number of hours back must be specified`,
    removeAllAccess: () => `Are you sure to remove all accesses from the well?`,
    wellboreTagDeleteConfirm: () => `No wells are using this tag, or the tag has no value on any of the wells using it, and is therefore safe to delete. \nAre you sure you want to permanently delete it?`,
    companyAndUserRoleDoNotMatch: () => `The company of the user and the company of the role do not match.\nThis is a "Company" role, which is typically only added to users within the same company that owns the role. \nAre you sure you want to continue?`,
    majorCompanyContractorRole: () => `The company of the user is marked as a major company, so this user should typically not be given a contractor role. \nAre you sure you want to continue?`,
    requiresNumberOrBlank: () => 'You must enter a number or else leave blank.',
    batchUploadFileRequired: () => 'This entry type requires the entry to have at least one file.',
    batchUploadCriteriaRequired: () => 'Please select at least one filter condition in the distribution panel.',
    batchUploadResultRequired: () => 'Please select one of the upload results.',
    entryRuleRequiredOnHelp: () => `If the service can't find a file that matches the file type and name criteria, the check will fail.`,
    entryRuleRequiredOffHelp: () => `
        If the service find a file that matches the file type and name criteria, it will process it according to this rule, and that will contribute to whether the entry passes or fails.<br>
        However, if the service can't find a file that matches the file type and name criteria, the check will not fail.
    `,
    entryRuleRequiredDisabledHelp: () => `
        <b>Required</b> is disabled because <b>No File Required</b> is active on this entry type. 
    `,
    entryRuleCheckMultipleOnHelp: () => `This rule will be used to check <b><i>all</i></b> files that match the name criteria.`,
    entryRuleCheckMultipleOffHelp: () => `This rule will be used to check the <b><i>first</i></b> file that matches the name criteria.`,
    deleteMaintInvoiceConfirm: () => `This will completely delete this invoice and all its data.\nThe next Maintenance Invoice generated for this company will include the data this invoice would have covered.\nContinue?`,
    maintenanceInvoiceAddModalHelp: () => `
        Clicking <b>Save</b> will generate and save a Maintenance Invoice for this company.<br />
        This may take a while depending on the following company-specific factors:
        <p>
            <ul>
                <li>How many wells exist.</li>
                <li>How long since the last time a Maintenance Invoice was added.</li>
                <li>How many wells are being invoiced for the first time.</li>
            </ul>
        </p>
        Only the most recent Maintenance Invoice can be edited or deleted.
    `,
    maintenanceInvoiceStartHelp: () => `<b>Maintenance Invoice Start</b> determines how many days since last upload to any well that the system will wait before including that well on Maintenance Invoices.`,
    maintenanceInvoiceAddHelp_Company: () => `
        <b>Company</b> only shows companies where the following is true: 
        <ul>
            <li>
                The company has wells.
            </li>
            <li>
                <b>Maintenance Invoicing</b> company setting is <i>On</i>.
            </li>
        </ul>
    `,
    prodInvoiceAddModalHelp: () => `
        Clicking <b>Save</b> will generate any Production invoices for this company, for any months that have not yet been invoiced.<br />
        This may take a while depending on the following company-specific factors: 
        <p>
            <ul>
                <li>How many wells exist.</li>
                <li>How long since the last Production Invoice was added.</li>
                <li>How many different companies are partners on wells with Production data. </li>
            </ul>
        </p>
    `,
    deleteProdInvoiceConfirm: () => `This will completely delete this invoice and all its data.\nThe next time Production invoices are generated for this company, this invoice will be regenerated.\nContinue?`,

    copyAccessUserHelp: () => `
        <b>Copy From</b> selects the user you want to copy access from, and
        includes their Role and Role Type, to help ensure you're choosing the
        correct one.<br />
        <b>Only users from the same company as the current user are shown.</b>`,
    copyAccessSelectionHelp: () => `
        Select one or more roles to copy to this user.<br />
        Use the tabs for each role (to the right) to review the well access that will be copied.
    `,
    selectRole: () => `Please select at least one role.`,
    prodInvoiceBillStartDateRequired: () => `You must specify a <b>Billing Start Date</b> if <b>Production Invoicing</b> is turned on.`,
    prodInvoiceBillStartDateHelp: () => `
        <b>Billing Start Date</b> is the date on which the system will start collecting data for invoicing for the use of Production data services for this company's wells. 
        This will effectively set the first month that can be invoiced.
    `,
    prodInvoiceAdditionalColumnsHelp: () => `<b>Additional Columns</b> allows you to select well properties or tags that will appear as columns on the invoice. `,
    selectRole: () => `Please select at least one role.`,
    workoverInvoiceAddHelp: () => `Clicking <b>Save</b> will generate Workover invoices for all eligible wells of the selected company.  
    All generated invoices will be created with status <b>Incomplete</b>, to indicate they require review. `,
    selectRole: () => `Please select at least one role.`,
    entryTypeMessageWarning: () => `Once this message is attached to an Entry Type (on the Entry Type edit page), it will appear on the Entry add/edit page whenever that entry type is selected. <br />
     It's intended to help inform the user regarding exactly what they need to include in the entry for it to pass Entry Check. `,
    deleteEntryTypeMessageConfrim: () => `This message will be removed from any Entry Type it's attached to, and then permanently deleted.  \r\nContinue?`,
    deleteWellboreHeadTemplate: () => `This will result in the well header display returning to the Default template for all wells of this company.  \r\nContinue?`,


    combinedPdfReportScheduledOnHelp: () => `The report will run, and be delivered to selected recipients, on the schedule specified below.`,
    combinedPdfReportScheduledOffHelp: () => `The report will only run when the <b>Download</b> button is clicked. It will not be delivered to selected recipients.`,
    apiRegexValidationFalied: () => `<b>API match</b> and <b>API replace</b> must both either contain a regex or be empty`,
    entryRuleValidationFalied: () => `Required In Name and Required In Content cannot both be empty.`,
}
